import { ProductSliderSources } from "@omni/types/components/product/enums/productSliderResource.enum";

import { ProductSlider } from "@/components/Product/ProductSlider/productSlider.container";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { useProductPageContext } from "../../context/productPage.context";
import { ProductPageConfig } from "../../productPage.config";

export const RecommendProductsSliderContainer = () => {
    const { t } = useGranite();
    const { product, algoliaRecommendParams, sliders } =
        useProductPageContext();

    if (!sliders?.[ProductSliderSources.AlgoliaRecommend]) {
        return null;
    }

    return (
        <ProductSlider
            title={t("sliders.frequentlyBoughtTogether.title")}
            source={ProductSliderSources.AlgoliaRecommend}
            algoliaRecommendParams={algoliaRecommendParams}
            breakpointsConfig={{
                hidden: [],
                layoutSettings: ProductPageConfig.sliders.recommend
            }}
            productTileConfig={{
                amountOfFeatures: 0,
                useInsidePadding: false,
                showButton: false,
                showCategoryLink: false,
                allowInstantAddToCart: false
            }}
            sku={product.sku}
            prefetchedProducts={
                sliders?.[ProductSliderSources.AlgoliaRecommend]
            }
        />
    );
};
